
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.442 9.219c.031-.262.052-.535.052-.819 0-.284-.02-.557-.063-.819l1.775-1.386a.434.434 0 00.105-.535L14.63 2.75c-.105-.189-.326-.252-.515-.189l-2.09.84a6.152 6.152 0 00-1.417-.819L10.294.357A.42.42 0 009.874 0h-3.36a.409.409 0 00-.41.357L5.79 2.583c-.515.21-.987.493-1.418.819l-2.09-.84a.415.415 0 00-.514.189L.088 5.66a.407.407 0 00.105.535l1.775 1.386a5.278 5.278 0 00-.074.819c0 .273.021.556.063.819L.183 10.605a.434.434 0 00-.105.535l1.68 2.909c.105.189.325.252.514.189l2.09-.84c.44.336.903.609 1.417.819l.315 2.226c.042.21.21.357.42.357h3.36c.21 0 .389-.147.41-.357l.315-2.226c.514-.21.987-.494 1.417-.819l2.09.84c.189.074.41 0 .514-.189l1.68-2.909a.407.407 0 00-.105-.535l-1.753-1.386zM8.194 11.55a3.16 3.16 0 01-3.15-3.15 3.16 3.16 0 013.15-3.15 3.16 3.16 0 013.15 3.15 3.16 3.16 0 01-3.15 3.15z","fill":"currentColor"}})])
          )
        }
      }
    